declare global {
  interface Window {
    _learnq?: Array<any> & {
      push: (args: any[]) => void
    }
    _klOnsite?: Array<any> & {
      push: (args: any[]) => void
    }
  }
}

export default defineNuxtPlugin(() => {
  // Only load Klaviyo on client-side
  if (import.meta.client) {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', loadKlaviyo)
    }
    else {
      loadKlaviyo()
    }
  }

  function loadKlaviyo() {
    // Initialize Klaviyo arrays
    if (!window._learnq) {
      window._learnq = [] as any
    }
    if (!window._klOnsite) {
      window._klOnsite = [] as any
    }
    
    // Check if Klaviyo script is already loaded
    const existingScript = document.querySelector('script[src*="klaviyo.js"]')
    if (existingScript) {
      return
    }

    // Create script element
    const script = document.createElement('script')
    script.src = 'https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=XXthe2'
    script.async = true
    script.defer = true

    // Add error handling
    script.onerror = () => {
      console.warn('Klaviyo script failed to load')
    }

    // Add success handler
    script.onload = () => {
      console.log('Klaviyo script loaded successfully')
    }

    document.head.appendChild(script)
  }
})
